import { Component, ViewChild, ViewContainerRef } from '@angular/core';

@Component({
  template: '<div #emptyContainer></div>',
  standalone: true
})
export class EmptyContainerComponent {
  @ViewChild('emptyContainer', { read: ViewContainerRef, static: true }) viewContainerRef!: ViewContainerRef;
}
